export default __webpack_public_path__ + "static/climate-map-47988380e7011aa64422c99103ceaa90.svg";